import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { useAdvertise } from '@/store/useAdvertise';
import { BUILDERS_STEPS } from '@/config/advertiseSteps';

export default function BuildersCompany() {
  const navigate = useNavigate();
  const builders = useAdvertise((s) => s.builders);
  const setField = useAdvertise((s) => s.setField);

  const set = (patch) => setField('builders', patch);
  const canProceed = builders.companyName && builders.city && builders.state;

  return (
    <AdvertiseLayout
      trackLabel="Community Boost"
      steps={BUILDERS_STEPS}
      currentStepId="company"
      title="Tell us about your company"
      sidebar={<AdvertiseSideSummary items={[{ label: 'Company', value: builders.companyName }, { label: 'HQ', value: [builders.city, builders.state].filter(Boolean).join(', ') }]} />}
      footer={<AdvertiseFooterNav showBack={false} nextDisabled={!canProceed} onNext={() => navigate('/advertise/builders/portfolio')} />}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="sm:col-span-2"><Label>Company name</Label><Input value={builders.companyName} onChange={(e) => set({ companyName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-company-name" /></div>
        <div><Label>HQ city</Label><Input value={builders.city} onChange={(e) => set({ city: e.target.value })} className="mt-1.5 rounded-xl" data-testid="builders-company-city" /></div>
        <div><Label>HQ state</Label><Input value={builders.state} onChange={(e) => set({ state: e.target.value.toUpperCase() })} maxLength={2} className="mt-1.5 rounded-xl uppercase" data-testid="builders-company-state" /></div>
        <div><Label>Website</Label><Input value={builders.website} onChange={(e) => set({ website: e.target.value })} placeholder="https://" className="mt-1.5 rounded-xl" data-testid="builders-company-website" /></div>
        <div>
          <Label>Number of communities</Label>
          <Select value={builders.communityCount} onValueChange={(v) => set({ communityCount: v })}>
            <SelectTrigger className="mt-1.5 rounded-xl" data-testid="builders-company-community-count"><SelectValue placeholder="Select a range" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="1">1</SelectItem>
              <SelectItem value="2-5">2–5</SelectItem>
              <SelectItem value="6-20">6–20</SelectItem>
              <SelectItem value="20+">20+</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </AdvertiseLayout>
  );
}
